"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.create.title': 'Crear Prueba de Bot',
};
